import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { App } from './app';
import { observer, Provider } from 'mobx-react';
import { CurrentUserStore } from "./user/currentUserStore";
import { LoginPage } from './user/LoginPage';
import { ConfigProvider, theme, Button, Typography, Space } from 'antd';
import firebase from 'firebase/compat/app';

const { Text, Title } = Typography;

function AccessDenied({ user }) {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            background: '#0e1117',
            gap: 16,
        }}>
            <Title level={3} style={{ color: 'rgba(255,255,255,0.88)', margin: 0 }}>Access denied</Title>
            <Text style={{ color: 'rgba(255,255,255,0.55)' }}>
                {user?.email} does not have back-office access. Ask an admin to add you on the Users page.
            </Text>
            <Button onClick={() => firebase.auth().signOut()}>Sign out</Button>
        </div>
    );
}

@observer
export class RouterOutlet extends React.Component {
    currentUserStore = new CurrentUserStore();

    render() {
        const { isLoading, isAuthenticated, hasAccess, user } = this.currentUserStore;

        if (isLoading) {
            return (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#0e1117' }}>
                    <Text style={{ color: 'rgba(255,255,255,0.55)' }}>Loading...</Text>
                </div>
            );
        }

        if (!isAuthenticated) {
            return <LoginPage />;
        }

        if (!hasAccess) {
            return <AccessDenied user={user} />;
        }

        return (
            <ConfigProvider
                theme={{
                    algorithm: theme.darkAlgorithm,
                    token: {
                        colorBgContainer: '#1a1f2e',
                        colorBgLayout: '#13172200',
                        colorBgElevated: '#242938',
                        colorBorder: 'rgba(255,255,255,0.12)',
                        colorBorderSecondary: 'rgba(255,255,255,0.08)',
                        colorText: 'rgba(255,255,255,0.88)',
                        colorTextSecondary: 'rgba(255,255,255,0.55)',
                        colorPrimary: '#7b6ef6',
                        fontFamily: "'Roboto', sans-serif",
                    },
                    components: {
                        Layout: {
                            siderBg: '#141824',
                            headerBg: '#141824',
                            bodyBg: '#0e1117',
                        },
                        Menu: {
                            darkItemBg: '#141824',
                            darkItemSelectedBg: 'rgba(123,110,246,0.18)',
                            darkItemSelectedColor: '#fff',
                            darkItemHoverBg: 'rgba(255,255,255,0.06)',
                            darkItemHoverColor: '#fff',
                            darkItemColor: 'rgba(255,255,255,0.60)',
                            itemBorderRadius: 8,
                        },
                    },
                }}
            >
                {/* basename is "" in prod builds; PR previews build with PUBLIC_URL=/pr-<N> */}
                <Router basename={process.env.PUBLIC_URL}>
                    <Provider currentUserStore={this.currentUserStore}>
                        <App />
                    </Provider>
                </Router>
            </ConfigProvider>
        );
    }
}
